<lvr-simple-panel>
	@if (!workplace()) {
		<span title>{{ 'workplace.workplace_view.workplace' | transloco }}</span>
	} @else {
		<span title>{{ workplace()?.name }}</span>
	}
	<div content>
		@if (!workplace()) {
			{{ 'workplace.workplace_view.no_workplaces' | transloco: { name: institutionName() } }}
		} @else {
			<table>
				<thead>
					<tr>
						<th scope="col">{{ 'base.field.group.address' | transloco }}</th>
						<th scope="col">{{ 'base.field.contact_point.title' | transloco }}</th>
						@if (user().roles?.id === eaaRole) {
							<th scope="col">{{ 'workplace.workplace_view.branch' | transloco }}</th>
						}
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{{ workplace()?.address?.streetAndHouseNumber }}<br />{{ workplace()?.address?.postalCodeAndCity }}</td>
						<td>
							<ul>
								@for (contactPoint of workplace()?.contactPoints; track contactPoint.id) {
									<li>{{ contactPoint.contactValue }}<br />{{ contactPoint.remark }}</li>
								}
							</ul>
						</td>
						@if (user().roles?.id === eaaRole) {
							<td>
								{{ workplace()?.industryName }}
							</td>
						}
					</tr>
				</tbody>
			</table>
		}
	</div>
</lvr-simple-panel>
